<template>
    <li
        v-tooltip.right="{
            content: item.label,
            disabled: !navbarCollapse,
        }"
    >
        <div
            v-if="item.childrens"
            class="overflow-hidden"
        >
            <button
                :class="['flex items-center gap-2 w-full py-2 px-2 rounded hover:bg-transparent-dark-06', { 'bg-gray-300 text-black': active }, { 'text-gray-700': !active }]"
                @click="onDropdownClick"
            >
                <slot name="icon">
                    <div :class="['flex justify-center', { 'flex-1': navbarCollapse }]">
                        <BaseIcon
                            :icon-name="item.icon"
                            :icon-color="active ? '#221D25' : '#5A5751'"
                            class="w-6 h-6"
                        >
                            <component :is="item.icon" />
                        </BaseIcon>
                    </div>
                </slot>
                <slot>
                    <span :class="['flex-1 text-sm/6 text-left font-semibold truncate', { hidden: navbarCollapse }]">
                        {{ item.label }}
                    </span>
                </slot>
                <slot
                    v-if="!navbarCollapse"
                    name="suffix"
                    :toggle-dropdown="onDropdownClick"
                >
                    <YpIcon
                        name="select-down"
                        class="transition-all duration-300"
                        :class="isOpen && 'rotate-180'"
                        size="sm"
                    ></YpIcon>
                </slot>
            </button>

            <div class="z-0 overflow-hidden">
                <transition
                    :duration="150"
                    enter-from-class="-translate-y-full"
                    enter-to-class="translate-y-0"
                    enter-active-class="transition duration-400 ease-out"
                    leave-active-class="transition duration-400 ease-in"
                    leave-from-class="translate-y-0"
                    leave-to-class="-translate-y-full"
                >
                    <div v-if="(isOpen || active) && !navbarCollapse">
                        <ul>
                            <li
                                v-for="(subItem, index) in item.childrens"
                                :key="index"
                            >
                                <RouterLink
                                    :to="{ name: subItem.route }"
                                    :class="[
                                        'block w-full pl-10 py-1 px-2 transition-all rounded hover:bg-transparent-dark-06 text-gray-700 no-underline',
                                        { 'bg-gray-300 text-black': isRouteActive(subItem) },
                                        { '!text-black': isRouteActive(subItem) },
                                    ]"
                                    v-bind="$attrs"
                                >
                                    <span class="flex-1 transition text-sm/6 font-medium truncate">
                                        {{ subItem.label }}
                                    </span>
                                </RouterLink>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
        </div>
        <component
            v-else
            :is="item.tag"
            :to="{ name: item.route }"
            :class="[
                'flex items-center gap-2 w-full py-2 px-2 transition-all rounded hover:bg-transparent-dark-06 no-underline',
                { 'bg-gray-300 text-black': active },
                { 'text-gray-700': !active },
            ]"
            v-bind="$attrs"
        >
            <slot name="icon">
                <div :class="['flex justify-center', { 'flex-1': navbarCollapse }]">
                    <BaseIcon
                        v-if="item.icon"
                        :icon-name="item.icon"
                        :icon-color="active ? '#221D25' : '#5A5751'"
                        class="w-6 h-6"
                    >
                        <component :is="item.icon" />
                    </BaseIcon>
                </div>
            </slot>
            <slot>
                <span :class="['flex-1 text-sm/6 text-left font-semibold truncate', { hidden: navbarCollapse }]">
                    {{ item.label }}
                </span>
            </slot>
            <slot name="suffix" />
        </component>
    </li>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseIcon from '@/icons/BaseIcon';
import IconHome from '@/icons/IconHome';
import IconDashboard from '@/icons/IconDashboard';
import IconMoney from '@/icons/IconMoney';
import IconBankStatement from '@/icons/IconBankStatement';
import IconBanner from '@/icons/IconBanner';
import IconMarketing from '@/icons/IconMarketing';
import IconWorkBag from '@/icons/IconWorkBag';
import IconCodeEditor from '@/icons/IconCodeEditor';
import YpIcon from '@/components/core/YpIcon.vue';

export default {
    inheritAttrs: false,
    components: {
        BaseIcon,
        IconHome,
        IconDashboard,
        IconMoney,
        IconBankStatement,
        IconMarketing,
        IconBanner,
        IconWorkBag,
        IconCodeEditor,
        YpIcon,
    },
    props: {
        item: null,
        id: null,
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        ...mapGetters({
            navbarCollapse: 'navbar/navbarCollapse',
        }),
        active() {
            const isActive =
                this.item.route === this.$route.name ||
                this.item.groupName === this.$route.name.split('.')[0] ||
                this.item.childrens?.some((child) => child.route === this.$route.name);

            return isActive;
        },
        linkAttr() {
            return this.item.tag === 'a' ? 'href' : 'to';
        },
    },
    methods: {
        onDropdownClick() {
            if (this.navbarCollapse) {
                this.$parent.toggleNavbarCollapse(false);
            }

            if (this.item.childrens && this.item.childrens.length) {
                this.$router.push({ name: this.item.childrens[0].route });
            }

            this.isOpen = !this.isOpen;
        },
        isRouteActive(subItem) {
            const currentRoute = this.$route.name;
            const baseRoute = subItem.route;

            if (currentRoute === baseRoute) return true;

            if (currentRoute.startsWith(baseRoute + '.')) return true;

            return false;
        },
    },
};
</script>
